import StandardTabPanel from "../../../../ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../../ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ providerId, activeTab, children }) {
  const allTabs = [
    {
      key: "hours-of-operation",
      name: "Hours of Operation",
      isDisabled: false,
      permission: null,
      href: `/provider/${providerId}/location-info/hours-of-operation`,
    },
    {
      key: "services",
      name: "Services Provided",
      isDisabled: false,
      permission: null,
      href: `/provider/${providerId}/location-info/services`,
    },
    {
      key: "users",
      name: "Users",
      isDisabled: true,
      permission: null,
      href: `/provider/${providerId}/location-info/users`,
    },
    {
      key: "contacts",
      name: "Contacts",
      isDisabled: true,
      permission: null,
      href: `/provider/${providerId}/location-info/contacts`,
    },
  ];

  return (
    <StandardTabPanel
      id="subtab"
      activeTab={activeTab}
      tabList={allTabs}
      headerTabSx={TAB_STYLES.SUB_TAB.SX}
      headerTabIndicatorSx={TAB_STYLES.SUB_TAB.TAB_INDICATOR_SX}
    >
      <section className="flex h-full min-h-0 flex-col p-4">{children}</section>
    </StandardTabPanel>
  );
}
